module.exports = __webpack_public_path__ + "img/icn_more.987f5e11.svg";